import { useQuery } from '@tanstack/react-query';

import { GetAskAIAnswerApiResponse } from '../apis';

import { clientAxios } from '@/shared/api';
import { ApiResponse, ArticleItemProps } from '@/shared/types';
import { PATH } from '@/shared/constants';
interface useGetAskAIAnswerQueryResponse {
  answerText: string;
  questionText: string;
  contentsItems: ArticleItemProps[];
}

const useGetAskAIAnswerQuery = ({
  questionHashKey,
}: {
  questionHashKey?: string;
}) => {
  return useQuery({
    queryKey: ['getAskAIAnswerApi', questionHashKey],
    queryFn: async () => {
      const { data } = await clientAxios.get<
        ApiResponse<GetAskAIAnswerApiResponse>
      >('/getAskAIAnswerApi/', { params: { questionHashKey } });

      const { answer_text, question_text, quoted } = data.data;

      const contentsItems: ArticleItemProps[] = quoted.map((item) => {
        const {
          contents,
          news: {
            id,
            author_name,
            author_image,
            author_url_identifier,
            category_flag,
            category_kor,
            is_popular_news,
            read_time,
            repr_date_published,
            thumbnail_image,
            title,
          },
        } = item;

        return {
          id,
          href: `${PATH.DETAIL}/${id}`,
          title: title,
          category: category_kor,
          categoryHref: `${PATH.LIST}/${category_flag}`,
          description: contents.replace(/&nbsp;/g, ' '),
          thumbnail: thumbnail_image,
          articleInfo: {
            time: read_time,
            date: repr_date_published,
            isPopular: is_popular_news,
          },
          author: {
            name: author_name,
            href: `${PATH.HOME}/@${author_url_identifier}`,
            imgUrl: author_image,
          },
        };
      });

      const response: useGetAskAIAnswerQueryResponse = {
        answerText: answer_text,
        questionText: question_text,
        contentsItems,
      };

      return response;
    },
    enabled: !!questionHashKey,
  });
};

export default useGetAskAIAnswerQuery;
